<mat-card class="section appendix-card">
  <mat-card-content>
    <div class="section-heading-wrapper">
      <h3 class="section-heading">{{ documentNode?.name }}</h3>
      <div class="appendix-controls">
        <button
          mat-mini-fab
          color="primary"
          class="render-all-fab"
          matTooltip="Render all PDF pages (confirm)"
          aria-label="Render all pages"
          (click)="confirmRenderAll()"
        >
          <mat-icon>layers</mat-icon>
        </button>
      </div>
    </div>

    <div class="appendix-wrapper" #appendixWrapper *ngIf="links.length">
      <ul class="appendix-list">
        <li *ngFor="let lnk of links; let i = index; trackBy: trackLink">
          <div class="appendix-item">
            <!-- For PDFs we render a labeled bordered block; for others show the normal heading -->
            <ng-container *ngIf="isPdf(lnk); else normalHeading">
              <div class="appendix-pdf">
                <div class="appendix-pdf-header">
                  <div class="appendix-pdf-title">{{ getDisplayText(lnk) }}</div>
                  <div class="appendix-pdf-meta">{{ getFileName(lnk) || 'PDF document' }}</div>
                </div>
                <div class="appendix-pdf-body">
                  <app-pdf-thumbnail
                    [source]="getFileHref(lnk) || parsePdfBase64(lnk)"
                    [width]="appendixWidth"
                    [renderAll]="renderAllConfirmed"
                  ></app-pdf-thumbnail>
                </div>
              </div>
            </ng-container>
            <ng-template #normalHeading>
              <h4 class="appendix-item-heading">{{ getDisplayText(lnk) }}</h4>
            </ng-template>

            <!-- Always render images if available -->
            <ng-container *ngIf="getImageSrc(lnk) as imgSrc">
              <div class="appendix-image"><img [src]="imgSrc" [alt]="getDisplayText(lnk)" style="width: 100%; height: auto" /></div>
            </ng-container>

            <!-- For non-image, non-pdf files show link to open/download -->
            <ng-container *ngIf="!isPdf(lnk) && !getImageSrc(lnk)">
              <a [href]="getFileHref(lnk) || '#'" target="_blank" rel="noopener">{{ getDisplayText(lnk) }}</a>
            </ng-container>
          </div>
          <!-- Page separator between items -->
          <div class="appendix-separator" *ngIf="i < links.length - 1"></div>
        </li>
      </ul>
    </div>
    <div class="appendix-empty" *ngIf="!links.length">
      <em>No appendix items</em>
    </div>
  </mat-card-content>
</mat-card>
